import React from 'react';

import {
  Confirmation,
  Insurance,
  PackageType,
  ShipFrom,
  Size,
  TrackingStatus,
  Weight,
  PackageContentDescriptionReadOnly,
  DutiesAndTaxes,
} from '../fields';

const ShipmentDisplayContent = () => {
  return (
    <>
      <TrackingStatus />
      <ShipFrom />
      <Weight />
      <Size />
      <PackageType />
      <PackageContentDescriptionReadOnly />
      <Confirmation />
      <Insurance />
      <DutiesAndTaxes />
    </>
  );
};

export default ShipmentDisplayContent;
